<template>
    <div class="subsidy-note" v-if="note.length">
        <img src="@/assets/img/warning.svg">
        {{ note }}
    </div>
</template>

<script>
    export default {
        name: "SubsidyNote",
        props: {
            note: {
                require: true,
                type: String,
            }
        }
    }
</script>

<style lang="scss" scoped>
    .subsidy-note {
        background: linear-gradient(282deg, #e05e00, #fdd442, #e05e00, #fdd442);
        background-size: 400% 400%;
        animation: ani1 1.8s infinite linear;
        height: 35px;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        padding-left: 25px;
        overflow: hidden;
        color: #FFFFFF;
        font-size: 16px;
        font-weight: 500;
        letter-spacing: 0;
        line-height: 22px;
        white-space: nowrap;
        cursor: pointer;

        img {
            margin-right: 5px;
        }
    }

    @keyframes ani1 {
        0% {
            background-position:0% 75%;
        }
        100% {
            background-position:100% 25%;
        }
    }
</style>